import { render, staticRenderFns } from "./SignDocumentsModal.vue?vue&type=template&id=123d5c6a&scoped=true&"
import script from "./SignDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./SignDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./SignDocumentsModal.vue?vue&type=style&index=0&id=123d5c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d5c6a",
  null
  
)

export default component.exports